import { Chart } from "primereact/chart";
import { getFontFamily } from "../services/util.service";
import { useTheme } from "../context/ThemeContext";
import { useEffect, useMemo, useState } from "react";

export default function DonutChart(
    { id, data, onSelect, className, selectedEventInEventsDistributionChart }: { id: string; data?: any; className?: string; onSelect?: (val: any) => void, selectedEventInEventsDistributionChart?: any }
) {

    // const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const isEventChart = id === "events-distribution";

    const { theme } = useTheme()
    const textColor = theme === 'light' ? '#374151' : '#f3f4f6';

    // useEffect(() => {
    //     if (!selectedEventInEventsDistributionChart) {
    //         setActiveIndex(null);
    //     }
    // }, [selectedEventInEventsDistributionChart]);

    const chartRegistry = [{
        id: { id },
        afterDraw: (chart: any) => {
            if (chart?.config?._config?.type === 'doughnut') {
                const { ctx, chartArea: { left, right, top, bottom } } = chart;
                const centerX = (left + right) / 2, centerY = (top + bottom) / 2;
                let total = 0;
                const meta = chart.getDatasetMeta(0);
                const data = chart.data.datasets[0].data;

                meta.data.forEach((_: any, index: number) => {
                    if (chart.getDataVisibility(index)) {
                        total += data[index];
                    }
                });
                ctx.save();
                ctx.font = `bold 24px ${fontFamily}`;
                ctx.fillStyle = textColor;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(total?.toLocaleString('en-IN') || '', centerX, centerY);
                ctx.restore();
            }
        }
    }]

    const handleClick = (events: any, elements: any[]) => {
        console.log(events, elements)
        if (!isEventChart || !elements?.length) return;

        const index = elements[0].index;
        const label = data?.labels?.[index];

        onSelect?.(label); // let parent handle toggle
    };

    const updatedData = data
        ? {
            ...data,
            datasets: data.datasets.map((ds: any) => ({
                ...ds,
                backgroundColor: ds.backgroundColor.map((color: string, i: number) => {
                    const selected = selectedEventInEventsDistributionChart || [];

                    return selected.length === 0 ||  selected.some((event: string) =>event.replaceAll('_',' ')?.toLowerCase() === data.labels[i]?.toLowerCase())
                        ? color
                        : `${color}33`;
                }),
            })),
        }
        : data;

    const [fontSize, setFontSize] = useState(
        Number(localStorage.getItem("appFontSize")) || 14
    );

    useEffect(() => {
        const handleFontSizeChange = () => {
            setFontSize(Number(localStorage.getItem("appFontSize")) || 14);
        };

        window.addEventListener("fontSizeChanged", handleFontSizeChange);

        return () => {
            window.removeEventListener("fontSizeChanged", handleFontSizeChange);
        };
    }, []);

    const [fontFamily, setFontFamily] = useState(getFontFamily());

    useEffect(() => {
        const handleFontFamilyChange = () => {
            setFontFamily(getFontFamily());
        };

        window.addEventListener("fontFamilyChanged", handleFontFamilyChange);

        return () => {
            window.removeEventListener("fontFamilyChanged", handleFontFamilyChange);
        };
    }, []);

    const options = useMemo(
        () => ({
            cutout: "60%",
            maintainAspectRatio: false,
            ...(isEventChart && { onClick: handleClick }),
            plugins: {
                legend: {
                    position: "bottom",
                    onClick: () => { },
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 8,
                        boxHeight: 8,
                        padding: 12,
                        color: textColor,
                        font: {
                            size: fontSize,
                            family: fontFamily
                        },
                    }
                },
                tooltip: {
                    titleFont: {
                        size: fontSize,
                        family: fontFamily
                    },
                    bodyFont: {
                        size: fontSize,
                        family: fontFamily
                    },
                    footerFont: {
                        size: fontSize,
                        family: fontFamily
                    },
                    callbacks: {
                        label: function (tooltipItem: any) {
                            const value = tooltipItem.raw;
                            return `${tooltipItem.label}: ${(value as number).toLocaleString()}`;
                        },
                    },
                }
            },
        }), [fontSize, theme, id, data, fontFamily]);

    return <Chart id={id} type="doughnut" data={!isEventChart ? data : updatedData} options={options} className={`w-full ${className ?? "h-64"}`} plugins={chartRegistry} />;
}
